import { LOCATION_CHANGE } from 'connected-react-router';
import { SET_UPDATE_USER_SUCCESS } from '../constants/ActionTypes';

export default function updateUserSuccess(state, action) {
    switch (action.type) {
        case SET_UPDATE_USER_SUCCESS:
            return action.form;
        case LOCATION_CHANGE:
            return undefined;
        default:
            return state;
    }
}
